import YouTubeIframeLoader from 'youtube-iframe';
import Vimeo from '@vimeo/player';
import computedStyle from 'computed-style';

export default class BackgroundVideo {
  static init(...parameters) {
    return new BackgroundVideo(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.background = document.querySelector(`#${block.id} > .background`);

    if (this.background) {
      this.video = document.querySelector(`#${block.id} > .background > .video`);
      if (!this.video) {
        return;
      }

      this.poster = document.querySelector(`#${block.id} > .background > .image`);

      this.paused = true;
      if (this.video && computedStyle(this.video, 'visibility') === 'visible') {
        this.videoType = this.video.dataset.videoType;
        this.videoStart = this.video.dataset.videoStart;

        if (this.videoType === 'youtube') {
          this.initYotube();
        }

        if (this.videoType === 'vimeo') {
          this.initVimeo();
        }
      }
    }
  }

  initYotube() {
    const player = this.video.querySelector('.player');
    const { videoId } = this.video.dataset;

    if (player && videoId) {
      YouTubeIframeLoader.load((YT) => {
        this.youtube = new YT.Player(player, {
          height: '100%',
          width: '100%',
          videoId,
          events: {
            onReady: (event) => {
              this.iframe = this.video.querySelector('iframe');
              event.target.mute();
              event.target.playVideo();
              this.onReady();
            },
            onStateChange: (event) => {
              switch (event.data) {
                case YT.PlayerState.PLAYING:
                  this.paused = false;
                  this.onPlay();
                  break;

                case YT.PlayerState.PAUSED:
                  this.paused = true;
                  this.onPause();
                  break;

                case YT.PlayerState.ENDED:
                  event.target.mute();
                  event.target.playVideo();
                  break;

                default:
              }
            },
          },
          playerVars: {
            start: this.videoStart,
            autoplay: 1, // Auto-play the video on load
            controls: 0, // Show pause/play buttons in player
            showinfo: 0, // Hide the video title
            modestbranding: 1, // Hide the Youtube Logo
            loop: 1, // Run the video in a loop
            fs: 0, // Hide the full screen button
            cc_load_policy: 0, // Hide closed captions
            iv_load_policy: 3, // Hide the Video Annotations
            autohide: 0,
            rel: 0, // Hide video controls when playing
            disablekb: 1, // disable the keyboard controls
          },
        });
      });
    }
  }

  initVimeo() {
    this.iframe = this.video.querySelector('iframe');

    // this.onReady();
    const player = this.video.querySelector('.player');
    if (player) {
      let isReady = false;
      const vimeo = new Vimeo(player);
      vimeo.ready().then(() => {
        vimeo.setCurrentTime(this.videoStart);
      });
      vimeo.on('play', () => {
        if (!isReady) {
          isReady = true;
          this.onReady();
        }
        vimeo.on('timeupdate', (data) => {
          if (data.percent > 0) {
            vimeo.off('timeupdate');
            this.paused = false;
            this.onPlay();
          }
        });
      });
      vimeo.on('pause', () => {
        vimeo.off('timeupdate');
        this.paused = true;
        this.onPause();
      });
      vimeo.setVolume(0);
      vimeo.getPaused().then((paused) => {
        if (!paused) {
          this.onPlay();
          if (!isReady) {
            isReady = true;
            this.onReady();
          }
        } else {
          vimeo.off('timeupdate');
        }
        this.paused = paused;
      });
      this.vimeo = vimeo;
    }
  }

  onReady() {
    this.onResize();
    window.addEventListener('resize', (event) => this.onResize(event));
  }

  onPlay() {
    if (this.poster) {
      this.poster.style.opacity = 0;
    }
  }

  onPause() {
    if (this.poster) {
      this.poster.style.opacity = 1;
    }
  }

  onResize() {
    let width = this.block.offsetWidth;
    let height = this.block.offsetHeight;

    if ((width / height) > (16 / 9)) {
      height = Math.ceil((width / 16) * 9) + 2; // Fix rounding error
      width = Math.ceil(width) + 2; // Fix rounding error

      this.iframe.style.width = `${width}px`;
      this.iframe.style.height = `${height}px`;
    } else {
      width = Math.ceil((height / 9) * 16) + 2; // Fix rounding error
      height = Math.ceil(height) + 2; // Fix rounding error

      this.iframe.style.width = `${width}px`;
      this.iframe.style.height = `${height}px`;
    }
  }
}
